import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { IContact } from './contact';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ContactService{

    private _contactApiURL: string = 'https://localhost:5001/api/Contact';

    constructor(private http: HttpClient){}

    public sendMail(contact: IContact):void{
        try{
            const httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type': 'application/json',                  
                  })
              };
            this.http.post<IContact>(this._contactApiURL, contact, httpOptions).subscribe(data => 
                {
                    console.log(data)
                });
        }
        catch(e)
        {
            console.log(e);
        }
    }

}